import { Alert, Button, Icon, Input, Modal } from 'antd';
import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import DualListBox from 'react-dual-listbox';
import AntSelect, { AntOption } from '../../../../common/component/AntSelect';
import Wrapper from '../../../../common/component/Wrapper';
import * as FnbService from '../../../../../../services/fnbService';
import * as Func from '../../../../../../helpers/functions';

import '../ListSKU/ListSKU.less';

const getMenuItemIds = (menuItems = []) => {
    return (menuItems || []).map(item => item.id || item);
};

class ListFnbProduct extends Component {
    state = {
        visible: false,
        outletIds: this.props.outletIds || [],
        menuIds: this.props.menuIds || [],
        outlets: [],
        menus: [],
        menuItems: [],
        selectedIds: getMenuItemIds(this.props.menuItemIds),
        selectedMenuItems: this.props.menuItemIds || [],
        menuItemFilter: '',
        loadingOutlets: false,
        loadingMenus: false,
        loadingItems: false,
    };

    componentDidUpdate(prevProps) {
        if (prevProps.menuItemIds !== this.props.menuItemIds) {
            this.setState({
                selectedIds: getMenuItemIds(this.props.menuItemIds),
                selectedMenuItems: this.props.menuItemIds || [],
            });
        }

        if (prevProps.outletIds !== this.props.outletIds) {
            this.setState({ outletIds: this.props.outletIds || [] });
        }

        if (prevProps.menuIds !== this.props.menuIds) {
            this.setState({ menuIds: this.props.menuIds || [] });
        }

        if (prevProps.propertyIds !== this.props.propertyIds) {
            this.resetWaterfallState();
            if (this.state.visible) {
                this.loadOutlets({ resetSelection: true });
            }
        }
    }

    render() {
        const { t, buttonText, className, propertyIds } = this.props;
        const { visible, outletIds, menuIds, outlets, menus, menuItemFilter, loadingOutlets, loadingMenus, loadingItems, selectedIds } = this.state;
        const hasProperties = (propertyIds || []).length > 0;

        return (
            <Fragment>
                <Button className={className} type="primary" onClick={this.showModal}>
                    {buttonText || 'Lựa chọn sản phẩm áp dụng'}
                </Button>
                <Modal
                    title="Chọn sản phẩm áp dụng"
                    width={1200}
                    visible={visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    maskClosable={false}
                >
                    {!hasProperties ? (
                        <Alert
                            type="warning"
                            showIcon
                            message="Vui lòng chọn Property trước khi chọn sản phẩm áp dụng."
                        />
                    ) : (
                        <Wrapper className="list-sku-tab">
                            <Wrapper className='list-sku-supplier-row'>
                                <Wrapper className='list-sku-supplier-field'>
                                    <div className='list-sku-supplier-label'>Outlet</div>
                                    <AntSelect
                                        showArrow
                                        showSearch
                                        allowClear
                                        mode="multiple"
                                        value={outletIds}
                                        loading={loadingOutlets}
                                        placeholder="Select Outlet"
                                        style={{ width: '100%' }}
                                        filterOption={this.selectFilterSearch}
                                        onChange={this.onChangeOutlets}
                                    >
                                        {outlets.map(outlet => (
                                            <AntOption key={outlet.id} value={outlet.id}>
                                                {this.getOptionLabel(outlet)}
                                            </AntOption>
                                        ))}
                                    </AntSelect>
                                </Wrapper>
                                <Wrapper className='list-sku-supplier-spacer' />
                                <Wrapper className='list-sku-supplier-field'>
                                    <div className='list-sku-supplier-label'>Menu</div>
                                    <AntSelect
                                        showArrow
                                        showSearch
                                        allowClear
                                        mode="multiple"
                                        value={menuIds}
                                        loading={loadingMenus}
                                        placeholder="Select Menu"
                                        style={{ width: '100%' }}
                                        filterOption={this.selectFilterSearch}
                                        onChange={this.onChangeMenus}
                                        disabled={!outletIds.length}
                                    >
                                        {menus.map(menu => (
                                            <AntOption key={menu.id} value={menu.id}>
                                                {this.getOptionLabel(menu)}
                                            </AntOption>
                                        ))}
                                    </AntSelect>
                                </Wrapper>
                            </Wrapper>
                            <Wrapper className='w-100'>
                                <Wrapper className='list-sku-single-filter'>
                                    <Input
                                        value={menuItemFilter}
                                        placeholder={t('action.search')}
                                        onChange={this.onChangeMenuItemFilter}
                                        disabled={!menuIds.length && !selectedIds.length}
                                        allowClear
                                    />
                                </Wrapper>
                                <DualListBox
                                    showHeaderLabels
                                    options={this.getMenuItemOptions()}
                                    available={this.getAvailableMenuItemValues()}
                                    selected={this.getDisplayedSelectedValues()}
                                    onChange={this.onChangeItems}
                                    disabled={loadingItems || (!menuIds.length && !selectedIds.length)}
                                    lang={{
                                        availableHeader: 'Menu item khả dụng',
                                        selectedHeader: 'Menu item đã chọn',
                                    }}
                                    icons={{
                                        moveLeft: <Icon type="left" className="mx-2" />,
                                        moveAllLeft: <Icon type="double-left" className="mx-2" />,
                                        moveRight: <Icon type="right" className="mx-2" />,
                                        moveAllRight: <Icon type="double-right" className="mx-2" />,
                                    }}
                                />
                            </Wrapper>
                        </Wrapper>
                    )}
                </Modal>
            </Fragment>
        );
    }

    showModal = () => {
        this.setState({ visible: true }, () => this.loadOutlets({ resetSelection: false }));
    };

    handleOk = () => {
        this.props.onChange({
            outletIds: this.state.outletIds,
            menuIds: this.state.menuIds,
            menuItemIds: this.getSelectedMenuItems(),
        });
        this.setState({ visible: false });
    };

    handleCancel = () => {
        this.setState({ visible: false });
    };

    resetWaterfallState = () => {
        this.setState({
            outlets: [],
            menus: [],
            menuItems: [],
            outletIds: [],
            menuIds: [],
            selectedIds: [],
            selectedMenuItems: [],
            menuItemFilter: '',
        });
    };

    loadOutlets = async ({ resetSelection = false } = {}) => {
        const propertyIds = this.props.propertyIds || [];
        if (!propertyIds.length) {
            this.resetWaterfallState();
            return;
        }

        this.setState({ loadingOutlets: true });
        try {
            const outlets = await FnbService.getFrontendOutlets({ propertyIds });
            if (resetSelection) {
                this.setState({
                    outlets,
                    menus: [],
                    menuItems: [],
                    outletIds: [],
                    menuIds: [],
                    selectedIds: [],
                    selectedMenuItems: [],
                    menuItemFilter: '',
                });
                return;
            }

            this.setState({ outlets }, () => {
                if (this.state.outletIds.length && !this.state.menus.length) {
                    this.loadMenus(this.state.outletIds);
                }
            });
        } catch (e) {
            if (resetSelection) {
                this.setState({ outlets: [], menus: [], menuItems: [], outletIds: [], menuIds: [], selectedIds: [], selectedMenuItems: [], menuItemFilter: '' });
            } else {
                this.setState({ outlets: [] });
            }
        } finally {
            this.setState({ loadingOutlets: false });
        }
    };

    onChangeOutlets = async (outletIds = []) => {
        this.setState({ outletIds, menuIds: [], menus: [], menuItems: [], selectedIds: [], selectedMenuItems: [], menuItemFilter: '' });
        if (!outletIds.length) return;

        this.loadMenus(outletIds);
    };

    loadMenus = async (outletIds = []) => {
        this.setState({ loadingMenus: true });
        try {
            const menus = await FnbService.getFrontendMenus({ outletIds });
            this.setState({ menus }, () => {
                if (this.state.menuIds.length && !this.state.menuItems.length) {
                    this.loadMenuItems(this.state.menuIds);
                }
            });
        } catch (e) {
            this.setState({ menus: [] });
        } finally {
            this.setState({ loadingMenus: false });
        }
    };

    onChangeMenus = async (menuIds = []) => {
        this.setState({ menuIds, menuItems: [], selectedIds: [], selectedMenuItems: [], menuItemFilter: '' });
        this.loadMenuItems(menuIds);
    };

    loadMenuItems = async (menuIds = []) => {
        if (!menuIds.length) {
            this.setState({ menuItems: [] });
            return;
        }

        this.setState({ loadingItems: true });
        try {
            const menuItems = await FnbService.getFrontendMenuItems({ menuIds });
            this.setState({ menuItems });
        } catch (e) {
            this.setState({ menuItems: [] });
        } finally {
            this.setState({ loadingItems: false });
        }
    };

    onChangeItems = selectedIds => {
        const displayedSelectedIds = this.getDisplayedSelectedValues();
        const hiddenSelectedIds = (this.state.selectedIds || []).filter(id => !displayedSelectedIds.includes(id));
        const nextSelectedIds = Array.from(new Set([...selectedIds, ...hiddenSelectedIds]));
        this.setState({
            selectedIds: nextSelectedIds,
            selectedMenuItems: this.mergeSelectedMenuItems(nextSelectedIds),
        });
    };

    onChangeMenuItemFilter = e => {
        this.setState({ menuItemFilter: e.target.value });
    };

    getOptionLabel = item => item?.code ? `[${item.code}] ${item.name}` : item?.name;

    getSelectedMenuItems = () => {
        return (this.state.selectedIds || []).map(id => {
            const item = (this.state.menuItems || []).find(menuItem => menuItem.id === id) ||
                (this.state.selectedMenuItems || []).find(menuItem => menuItem.id === id);
            return {
                id,
                code: item?.code,
                name: item?.name,
            };
        });
    };

    mergeSelectedMenuItems = selectedIds => {
        return (selectedIds || []).map(id => {
            const item = (this.state.menuItems || []).find(menuItem => menuItem.id === id) ||
                (this.state.selectedMenuItems || []).find(menuItem => menuItem.id === id);
            return {
                id,
                code: item?.code,
                name: item?.name,
            };
        });
    };

    getMenuItemOptions = () => {
        return this.getFilteredMenuItems().map(item => ({
            ...item,
            label: this.getOptionLabel(item),
            value: item.id,
            code: item.code || '',
        }));
    };

    getAvailableMenuItemValues = () => {
        const selectedIds = new Set(this.state.selectedIds || []);
        return this.getFilteredMenuItems()
            .map(item => item.id)
            .filter(id => !selectedIds.has(id));
    };

    getDisplayedSelectedValues = () => {
        const filteredIds = new Set(this.getFilteredMenuItems().map(item => item.id));
        return (this.state.selectedIds || []).filter(id => filteredIds.has(id));
    };

    getMergedMenuItems = () => {
        const mergedMap = new Map();
        (this.state.menuItems || []).forEach(item => {
            if (item?.id) mergedMap.set(item.id, item);
        });
        (this.state.selectedMenuItems || []).forEach(item => {
            const id = item?.id || item;
            if (id && !mergedMap.has(id)) {
                mergedMap.set(id, {
                    id,
                    code: item?.code,
                    name: item?.name,
                });
            }
        });
        return Array.from(mergedMap.values());
    };

    getFilteredMenuItems = () => {
        const filterInput = this.state.menuItemFilter || '';
        const menuItems = this.getMergedMenuItems();
        if (!filterInput) return menuItems;

        const inputText = Func.vietnameseStringToUnicode(filterInput.toLowerCase());
        return menuItems.filter(item => {
            const label = this.getOptionLabel(item);
            const optionText = Func.vietnameseStringToUnicode(String(label || '').toLowerCase());
            const codeText = Func.vietnameseStringToUnicode(String(item.code || '').toLowerCase());
            return optionText.indexOf(inputText) >= 0 || codeText.indexOf(inputText) >= 0;
        });
    };

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(String(option.props?.children || '').toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };
}

export default withTranslation()(ListFnbProduct);
